// extracted by mini-css-extract-plugin
export default {"tabs":"order-form-delivery_tabs__GChbR","validationErrOnTabs":"order-form-delivery_validationErrOnTabs__EwOPu","validationErrText":"order-form-delivery_validationErrText__Px6Bg"};